export default "__VITE_ASSET__b349d6f2__"